import StarBorderPurple500OutlinedIcon from "@mui/icons-material/StarBorderPurple500Outlined";
import StarIcon from "@mui/icons-material/Star";
import { Box, Typography } from "@mui/material";
import styles from "components/Templates/Template.module.scss";
import variables from "../../styles/partials/_variables.module.scss";
import { useNavigate } from "react-router-dom";
import { Template as TemplateData, TemplateFormValues } from "types/Template";
import { useAppSelector } from "utils/hooks/storeHooks";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { selectProviders } from "store/providers/selectors";
import { cardType } from "types/Provider";
import { fetchAllProviders } from "store/providers/thunks";

type Props = {
  id: number;
  imgURL: string;
  isStarred: boolean;
  title: string;
  templateInfo: TemplateData;
};

const Template = ({ id, imgURL, isStarred, title, templateInfo }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const providers = useAppSelector(selectProviders);
  const providerSelected = providers.find(
    (provider: cardType) => provider?.id === templateInfo.snapshot
  );
  // TODO: fix bug when selecting templates with different providers
  const values: TemplateFormValues = {
    cardId: id,
    cardValue: "",
    checkboxes: [""],
    name: templateInfo.name,
    providerId: providerSelected?.id,
    reportId: providerSelected?.reportId,
    templateState: templateInfo.configuration.template_state,
    viewMode: true,
  };

  useEffect(() => {
    dispatch(fetchAllProviders());
  }, [dispatch]);

  const handleViewTemplate = () => {
    navigate("/Graphs", { state: values });
  };

  return (
    <Box className={styles.template} onClick={handleViewTemplate}>
      <img alt={title} className={styles.templateSnapShot} src={imgURL} />
      <Box
        alignItems="center"
        display="flex"
        height="32px"
        justifyContent="space-between"
        paddingX="16px"
      >
        <Typography component="div" variant="body1">
          {title}
        </Typography>
        {isStarred ? (
          <StarIcon
            sx={{
              color: variables.mainBlue,
            }}
          />
        ) : (
          <StarBorderPurple500OutlinedIcon
            sx={{
              color: variables.mainBlue,
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default Template;
